/* Banner HealthDose — slideshow crossfade, pausable, congelado con
   reduced-motion. Custom element: sobrevive a re-renders del Theme
   Editor (shopify:section:load) sin listeners huérfanos. */

if (!customElements.get('hero-banner-hd')) {
  customElements.define('hero-banner-hd', class extends HTMLElement {
    connectedCallback() {
      this.imgs = this.querySelectorAll('.hd-hero__slides img');
      this.dots = this.querySelectorAll('.hd-hero__dots [data-slide-to]');
      this.pauseBtn = this.querySelector('.hd-hero__pause');
      this.i = 0;
      this.timer = null;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = parseInt(this.dataset.autoplay, 10) || 6000;

      if (this.imgs.length < 2) return;

      this.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-slide-to]');
        if (dot) {
          this.stop();
          this.go(parseInt(dot.dataset.slideTo, 10));
          return;
        }
        if (e.target.closest('.hd-hero__pause')) this.togglePause();
      });

      this.go(0);
      this.start();
    }

    disconnectedCallback() { this.stop(); }

    go(n) {
      this.i = (n + this.imgs.length) % this.imgs.length;
      this.imgs.forEach((im, k) => im.classList.toggle('is-on', k === this.i));
      this.dots.forEach((d, k) =>
        d.setAttribute('aria-current', String(k === this.i)));
    }

    start() {
      if (this.reduce) return;
      this.timer = setInterval(() => this.go(this.i + 1), this.interval);
    }

    stop() { clearInterval(this.timer); this.timer = null; }

    togglePause() {
      const playing = this.timer !== null;
      playing ? this.stop() : this.start();
      this.pauseBtn.setAttribute('aria-pressed', String(playing));
      this.pauseBtn.setAttribute('aria-label',
        playing ? 'Play banner slideshow' : 'Pause banner slideshow');
    }
  });
}
